import { render } from "./DesignForm.vue?vue&type=template&id=494b12b2&scoped=true&ts=true"
import script from "./DesignForm.vue?vue&type=script&lang=ts"
export * from "./DesignForm.vue?vue&type=script&lang=ts"

import "./DesignForm.vue?vue&type=style&index=0&id=494b12b2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-494b12b2"]])

export default __exports__